import React from 'react';
import LevelingRankPicker from '../levelingRankPicker/LevelingRankPicker';

export default class NWGearScore725 extends React.PureComponent {
    static minValue = 500;
    static maxValue = 725;

    static describeRank = rank => rank.toString();
    static getDefaultValue = () => [500, 650];

    static marks = {
        500: '500',
        600: '600',
        650: '650',
        675: '675',
        695: '695',
        710: '710',
        725: '725',
    };

    render() {
        const { ...rest } = this.props;

        return (
            <LevelingRankPicker
                {...rest}
                min={NWGearScore725.minValue}
                max={NWGearScore725.maxValue}
                marks={NWGearScore725.marks}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/newWorldLeveling/NWGearScore725.js